const CreatedByCell = ({ cell: { value } }) => {
    return value ? 'My Pharmacy' : 'Therigy';
};

export default CreatedByCell;
